import request from '@/utils/request'

// 获取商品详情信息
export const getGoodsDetailApi = (goodsId) => {
  return request.get('/goods/detail', {
    params: {
      goodsId
    }
  })
}

// 获取商品抢购动态（刚刚有哪些用户下单抢购该商品）
export const getGoodsRushLogsApi = (goodsId, limit = 10) => {
  return request.get('/goods/rushlogs', {
    params: {
      goodsId,
      limit
    }
  })
}

// 获取商品评论（支持分页，page 从 1 开始）
export const getGoodsCommentsApi = ({ goodsId, limit, page = 1 }) => {
  return request.get('/comment/listRows', {
    params: {
      goodsId,
      limit,
      page
    }
  })
}


// 记录商品浏览（用于后台「数据分析」的商品浏览量 / 访客数统计）
export const recordGoodsViewApi = (goodsId) => {
  return request.post('/stat/recordview', {
    goods_id: goodsId
  })
}